import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartnerDashboardComponent } from './partner-dashboard/partner-dashboard.component';
import { RoleGuardService } from '../service/security/role-guard.service';

const routes: Routes = [
  {
    path: 'utilisateur/partner/dashboard',
    component: PartnerDashboardComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['PLATFORM_ADMIN', 'SPAY_OPERATOR'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerRoutingModule { }
